import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import {
  headerLoadingConfig,
  tabsLoadingConfig,
  loadingConfig,
  shimmerPlaceholderConfig,
} from './UsageLoading.Config';
import styles from './UsageLoading.Styles';

function renderHeaderLoading(withHeaders) {
  if (!withHeaders) {
    return null;
  }

  return (
    <Shimmer config={headerLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
  );
}

function renderTabsLoading(withTabs) {
  if (!withTabs) {
    return null;
  }

  return <Shimmer config={tabsLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />;
}

function renderCard(withPercentageView, withGraphViewFooter, theme) {
  return (
    <View style={styles.cardContainerStyle(theme)}>
      <Shimmer
        config={loadingConfig(withPercentageView, withGraphViewFooter, theme)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    </View>
  );
}

const UsageLoading = ({ withPercentageView, withHeaders, withTabs, withGraphViewFooter }) => {
  const theme = useTheme();
  return (
    <>
      {renderHeaderLoading(withHeaders)}
      {renderTabsLoading(withTabs)}

      {_map([undefined, undefined, undefined], () =>
        renderCard(withPercentageView, withGraphViewFooter, theme),
      )}
    </>
  );
};

UsageLoading.defaultProps = {
  withPercentageView: true,
  withHeaders: false,
  withTabs: false,
  withGraphViewFooter: false,
};

UsageLoading.propTypes = {
  withPercentageView: PropTypes.bool,
  withHeaders: PropTypes.bool,
  withTabs: PropTypes.bool,
  withGraphViewFooter: PropTypes.bool,
};

export default UsageLoading;
